import React from 'react';
import styles from '../AnalysisConfig.module.css';

interface ConfigItemProps {
  label: string;
  value: React.ReactNode;
  onInfoClick?: () => void;
}

export const ConfigItem: React.FC<ConfigItemProps> = ({
  label,
  value,
  onInfoClick
}) => {
  return (
    <div className={styles.configItem}>
      <div className={styles.configLabel}>
        <span>{label}</span>
        {onInfoClick && (
          <i className="pi pi-question-circle" onClick={onInfoClick} />
        )}
      </div>
      <div className={styles.configValue}>{value}</div>
    </div>
  );
};
